import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

export const searchInputWrapper = css`
  position: relative;
`

export const breadcrumb = css`
  display: flex;
  text-overflow: ellipsis;
  overflow: hidden;
`

export const breadcrumbItem = (theme: Theme) => css`
  flex-shrink: 0;
  text-overflow: ellipsis;
  /* Crumb separator */
  &:not(:first-of-type) {
    margin-left: ${size[8]};

    ${breakpoint.up('sm')} {
      margin-left: ${size[12]};
    }

    &::before {
      content: '';
      display: inline-block;
      margin-right: ${size[8]};
      border-right: 1px solid ${theme.palette.neutral[600]};
      transform: rotate(20deg);
      height: 1em;
      vertical-align: middle;

      ${breakpoint.up('sm')} {
        margin-right: ${size[12]};
      }
    }
  }
`
